export function airBrakeLevelForSpeed(input: number, speed: number): number {
  const held = clamp01(input);
  if (held <= 0) return 0;
  const speedLevel = clamp01(speed);
  if (speedLevel <= 0) return 0;
  return held * Math.min(1, speedLevel / 0.35);
}

export function releaseHissHitForThrottleDrop(previousThrottle: number, nextThrottle: number, speed: number, load: number): number {
  const drop = clamp01(previousThrottle) - clamp01(nextThrottle);
  if (drop < 0.03) return 0;
  const engineEnergy = Math.max(clamp01(previousThrottle), clamp01(load), clamp01(speed) * 0.7);
  const offThrottle = 1 - clamp01(nextThrottle);
  return clamp01(Math.pow(drop, 0.72) * (0.18 + engineEnergy * 0.82) * offThrottle);
}

export function releaseHissEnvelope(current: number, hit: number, dt: number): number {
  const decay = Math.exp(-Math.max(0, dt) * 7.5);
  return Math.max(clamp01(current) * decay, clamp01(hit));
}

function clamp01(value: number): number {
  return Math.max(0, Math.min(1, value));
}
